import React, { Component } from 'react';
import { GenericSelect } from 'web-ui-components/lib/data/capture';
import countries from './countries';
import { Content } from '../infrastructure/content';
import { CountryUtil } from './utils/countryUtils';
import { COUNTRY_TYPE_ADDRESS } from './Address/addressUtils/addressConstants';

export class Country extends Component {
  constructor(props) {
    super(props);
    this.state = {
      options: countries.map(country => ({
        id: props.type === COUNTRY_TYPE_ADDRESS ? country.name : country.code,
        labelText: country.name
      }))
    };
    this.getOptions = this.getOptions.bind(this);
  }

  getOptions() {
    if (this.props.removeCountries && this.props.removeCountries.length > 0) {
      return CountryUtil.filterCountres(
        countries,
        this.props.removeCountries,
        'name',
        this.props.type
      );
    }
    return this.state.options;
  }

  render() {
    const { values, onChange, value, addressType } = this.props;
    return (
      <Content>
        {() => (
          <GenericSelect
            id={`${addressType}-generic-select-required`}
            {...this.props}
            items={this.getOptions()}
            selectedId={
              value || (values[addressType] && values[addressType].international)
                ? values[addressType].international.CountryNameInt
                : !values.countryOther
                ? null
                : values.countryOther
            }
            onChange={selectedId => {
              onChange(selectedId);
            }}
          />
        )}
      </Content>
    );
  }
}

export default Country;
